"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubitemsFieldLogic = void 0;
const intl_1 = require("../../locale/intl");
const texts_1 = require("../../texts");
const linked_record_field_1 = require("../linked-record-field");
class SubitemsFieldLogic extends linked_record_field_1.LinkedRecordFieldLogic {
    constructor() {
        super(...arguments);
        this.name = "subitemsfield";
        this.label = (0, intl_1.$t)(texts_1.subitemsFieldText.sub_items);
        this.icon = "journal";
        this.iconColor = "#3A86FF";
    }
    getViewControlRules(field) {
        return {
            ...super.getViewControlRules(field),
            fieldDuplicate: "disable",
        };
    }
    getInlineEditRules(field) {
        const baseInlineEditRules = super.getInlineEditRules(field);
        return {
            ...baseInlineEditRules,
            allowAddRecordToGroup: false,
        };
    }
    canChangeValue() {
        return false;
    }
    getDuplicateFieldOptions() {
        return {
            includeContentChecked: false,
            includeContentDisabled: true,
        };
    }
}
exports.SubitemsFieldLogic = SubitemsFieldLogic;
